import _ from "lodash";
import {returnButton, saveButton} from "../utils";

export const validateButton = (action, nextStatus) => ({
    type: 'action',
    action,
    nextStatus,
    tKey: 'Valider',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
})
export const transmitButton = (action, nextStatus, tKey) => ({
    type: 'action',
    action,
    nextStatus,
    tKey,
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'updateConfirmationMessage',
})

export const adjournButton = (action, nextStatus, tKey = 'Demander compléments') => ({
    type: 'action',
    action,
    nextStatus,
    tKey,
    bsStyle: 'warning',
    getUserConfirmation: true,
    confirmationMessage: 'adjournmentConfirmationMessage',
})

export const launchVisitButton = {
    action: 'launchVisit',
    type: 'action',
    nextStatus: 'visitInProgress',
    tKey: 'Demander la visite',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'visitLaunchConfirmationMessage',
};

export const validateVisitButton = {
    action: 'validateVisit',
    type: 'action',
    nextStatus: 'visitValidated',
    tKey: 'Confirmer un avis favorable',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'acceptanceConfirmationMessage',
};

export const rejectVisitButton = {
    action: 'rejectVisit',
    type: 'action',
    nextStatus: 'visitRejected',
    tKey: 'Émettre un avis défavorable',
    bsStyle: 'danger',
    getUserConfirmation: true,
    confirmationMessage: 'acceptanceConfirmationMessage',
};

export const acceptButton = {
    action: 'accept',
    type: 'action',
    nextStatus: 'accepted',
    tKey: 'Accepter',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'acceptanceConfirmationMessage',
}

export const rejectButton = {
    action: 'reject',
    type: 'action',
    nextStatus: 'rejected',
    tKey: 'Refuser',
    bsStyle: 'danger',
    bypassFormValidation: true,
    getUserConfirmation: true,
    confirmationMessage: 'rejectionConfirmationMessage',
}

export const getButtonsForModule = (application, context) => {
    const statusId = _.get(application, 'status.id');
    const { moduleId } = context.clientContext;
    let buttons = []

    switch (moduleId) {
        case 'm-C-application':
            if (['filed', 'updated'].includes(statusId)) {
                buttons = [
                    validateButton('preValidate', 'preValidated'),
                    adjournButton( 'adjourn', 'incomplete'),
                    rejectButton
                ]
            }

            if(['filed2', 'updated2'].includes(statusId)) {
                buttons = [
                    validateButton('validate2', 'validated2'),
                    adjournButton('adjourn2', 'incomplete2'),
                    rejectButton
                ]
            }

            if(['filed3', 'updated3'].includes(statusId)) {
                buttons = [
                    validateButton('validate3', 'completed'),
                    adjournButton('adjourn3', 'incomplete3'),
                    rejectButton
                ]
            }
            if(statusId === 'completed') {
                buttons = [launchVisitButton]
            }
            if(statusId === 'visitInProgress') {
                buttons = [validateVisitButton, rejectVisitButton]
            }
            if(['visitValidated', 'visitRejected'].includes(statusId)) {
                buttons = [acceptButton, rejectButton]
            }
            if(statusId === 'accepted') {
                buttons = [validateButton('validate', 'validated')]
            }
            break
        case 'm-C-file':
            if (['incomplete', 'preValidated', 'incomplete', 'incomplete2', 'validated2', 'incomplete3'].includes(statusId)) {
                let action = ''
                let nextStatus = ''
                let buttonTKey = ''
                switch (statusId) {
                    case 'incomplete':
                        action = 'update'
                        nextStatus = 'updated'
                        buttonTKey = 'JE TRANSMETS LE VOLET INSTITUTIONNEL'
                        break
                    case 'preValidated':
                        action = 'transmit2'
                        nextStatus = 'filed2'
                        buttonTKey = 'JE TRANSMETS LE VOLET ADMINISTRATIF'
                        break
                    case 'incomplete2':
                        action = 'update2'
                        nextStatus = 'updated2'
                        buttonTKey = 'JE TRANSMETS LE VOLET ADMINISTRATIF'
                        break
                    case 'validated2':
                        action = 'transmit3'
                        nextStatus = 'filed3'
                        buttonTKey = 'JE TRANSMETS LE VOLET SANITAIRE'
                        break
                    case 'incomplete3':
                        action = 'update3'
                        nextStatus = 'updated3'
                        buttonTKey = 'JE TRANSMETS LE VOLET SANITAIRE'
                        break
                }

                buttons = [transmitButton(action, nextStatus, buttonTKey), saveButton]
            }
            break
    }

    buttons.push(returnButton)

    return buttons
}


export const fieldsVisibilityRules = (animalGroupTypeId, hasShelters, hasOtherActivity = false) => [
    // Precision of the "Autre" activity
    { id: 'e_otherActivity', section: 'administrativeSection', condition: hasOtherActivity },

    // General (shelters)
    { id: 'e_DDPVisitReports', section: 'institutionalSection', condition: hasShelters },

    { id: 'e_sheltersSection', section: 'administrativeSection', condition: hasShelters },
    { id: 'e_adhesionShelters', section: 'administrativeSection', condition: hasShelters },

    { id: 'e_adhesionCapacityByAnimalTypeConfigs', section: 'administrativeSection', condition: animalGroupTypeId === 'domesticCarnivores' },

    { id: 'e_documentsSection2', section: 'administrativeSection', condition: animalGroupTypeId === 'domesticCarnivores' || hasShelters },
    { id: 'e_documentsSection3', section: 'sanitarySection', condition: animalGroupTypeId === 'domesticCarnivores' || hasShelters },


    // Domestic Carnivores
    ...[
        'bnoDeclarationReceipt',
        'nonCarnivoreSpeciesActivityDeclaration',
        'acacedCertificate',
        'adoptionContractAndCommitmentCertificate',
        'hostFamilyContract',
        'animalEntryExitRegisterExtract'
    ].map(id => ({
        id: `e_${id}`,
        section: 'administrativeSection',
        condition: animalGroupTypeId === 'domesticCarnivores'
    })),
    ...[
        'icpeDeclarationDogs',
        'dogWalkSchedule'
    ].map(id => ({
        id: `e_${id}`,
        section: 'administrativeSection',
        condition: hasShelters && animalGroupTypeId === 'domesticCarnivores'
    })),
    ...[
        'healthRegulationFile',
        'veterinaryAdoptionCertificate'
    ].map(id => ({
        id: `e_${id}`,
        section: 'sanitarySection',
        condition: animalGroupTypeId === 'domesticCarnivores'
    })),
    ...[
        'lastVeterinaryVisitReport',
        'healthMonitoringRegisterExtract',
        'selfInspectionStrategy'
    ].map(id => ({
        id: `e_${id}`,
        section: 'sanitarySection',
        condition: hasShelters && animalGroupTypeId === 'domesticCarnivores'
    })),

    // Equids
    ...[
        'breedingRegister',
        'animalHoldingLocationDeclaration',
        'commitmentAndKnowledgeCertificate',
        'animalWelfareOfficerDeclaration'
    ].map(id => ({
        id: `e_${id}`,
        section: 'administrativeSection',
        condition: hasShelters && animalGroupTypeId === 'equids'
    })),
    {
        id: 'e_lastIfceInspectionReport',
        section: 'sanitarySection',
        condition: hasShelters && animalGroupTypeId === 'equids'
    },

    // Farm Animals
    {
        id: 'e_gdsFarmSummarySheet',
        section: 'administrativeSection',
        condition: hasShelters && animalGroupTypeId === 'farmAnimals'
    },
    {
        id: 'e_prophylaxisOrDdppExemptionReport',
        section: 'sanitarySection',
        condition: hasShelters && animalGroupTypeId === 'farmAnimals'
    },

    // Wildlife
    ...[
        'openingAuthorizationPrefecture',
        'animalHandlingCapacityCertificate',
        'transportAuthorization'
    ].map(id => ({
        id: `e_${id}`,
        section: 'administrativeSection',
        condition: hasShelters && animalGroupTypeId === 'wildlife'
    })),

    // Shared
    {
        id: 'e_veterinarySanitaryDeclaration',
        section: 'sanitarySection',
        condition:
            animalGroupTypeId === 'domesticCarnivores' ||
            (hasShelters && ['equids', 'farmAnimals', 'wildlife'].includes(animalGroupTypeId))
    },
    {
        id: 'e_cerfa15045Receipt',
        section: 'administrativeSection',
        condition: hasShelters && ['equids', 'farmAnimals'].includes(animalGroupTypeId)
    }
];
